import React, { useState } from "react";

import TableContainer from "@mui/material/TableContainer";
import OrderSearchBody from "./OrderSearchBody";
import OrderSearchHeader from "./OrderSearchHeader";
import Paginate from "../../../../Utilities/Paginate";
import Loading from "../../../../Components/Interactive/Loading";

// Material UI Components
import Table from "@mui/material/Table";

const OrderSearchTableWidget = ({ orderResults, initRender, loading }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25)
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div>
      {loading ? (
        <div className="loading-widget">
          <Loading />
        </div>
    ) : (
      orderResults?.length > 0 ? (
        <div className="root">
          <TableContainer>
            <Table className="table" size={"small"}>
              <OrderSearchHeader />
              <OrderSearchBody 
                orderResults={orderResults}
                page = {page}
                rowsPerPage={rowsPerPage}
              />
            </Table>
          </TableContainer>
          <Paginate totalRowCount={orderResults.length} page={page} rowsPerPage={rowsPerPage} handleChange={handleChangePage} handleChangeRowsPerPage={handleChangeRowsPerPage} />
        </div>
      ) : (
        !initRender && (
          <h3 style={{ marginTop: "7rem", marginLeft: "40%", color: "grey", fontSize: "2rem" }}>No Results to Show</h3>
        )
      )
    )}
    </div>
  );
};

export default OrderSearchTableWidget;
